import { JepGraphic } from '@jeppesen-foreflight/jmkw-types';
import * as stringUtils from '../../../../utilities/string-format.utils';
import { NavigationFeatureType } from '../navigation-feature-type';
import { FeatureDetail } from './feature-detail';
import { AirportAttributesRaw } from './airport-attributes-raw';
import { AirportAttributes } from './airport-attributes';
import { Runway } from './runway-class';

export class Airport implements FeatureDetail {
  id: string;
  navType: NavigationFeatureType = 'airport';
  attributes: AirportAttributes;

  constructor(
    public graphic?: JepGraphic,
    public runways?: Runway[]
  ) {
    this.attributes = this._formatAttributes(graphic?.attributes);
    this.id = this._getId(graphic?.attributes);
  }

  private _getId(attrs?: AirportAttributesRaw): string {
    return (
      stringUtils.formatString(attrs?.icao) ||
      stringUtils.formatString(attrs?.domesticident)
    );
  }

  private _formatAttributes(attrs?: AirportAttributesRaw): AirportAttributes {
    if (!attrs) {
      return {
        coordinates: '',
        sourcelatitudedd: '',
        sourcelongitudedd: '',
        daylightSavings: false,
        elevation: '',
        iata: '',
        icao: '',
        id: '',
        location: '',
        name: '',
        timezone: ''
      };
    }

    return {
      coordinates: stringUtils.formatLatLong(attrs.latitude, attrs.longitude),
      sourcelatitudedd: attrs.sourcelatitudedd ?? '',
      sourcelongitudedd: attrs.sourcelongitudedd ?? '',
      daylightSavings: Boolean(attrs.hasdaylightsavingtime),
      elevation: this._formatElevation(attrs),
      iata: stringUtils.formatString(attrs.iata),
      icao: stringUtils.formatString(attrs.icao),
      id: this._getId(attrs),
      location: this._formatLocation(attrs),
      name: this._formatName(attrs.name),
      timezone: stringUtils.displayTimeZone(attrs.timezone)
    };
  }

  private _formatElevation(attrs: AirportAttributesRaw): string {
    if (attrs.elevationfeet !== undefined && attrs.elevationfeet !== null) {
      return stringUtils.formatMeasurement(attrs.elevationfeet, 'ft');
    }
    if (attrs.elevation !== undefined && attrs.elevation !== null) {
      return stringUtils.formatMeasurement(attrs.elevation, 'm');
    }
    return '';
  }

  private _formatLocation(attrs: AirportAttributesRaw): string {
    const location = stringUtils.formatString(attrs.location);
    const state = stringUtils.formatString(attrs.countrystate);
    const country = stringUtils.formatString(attrs.country);

    if (state && country) {
      return `${location}, ${state} ${country}`.trim();
    }
    if (country) {
      return `${location} ${country}`.trim();
    }
    return location;
  }

  private _formatName(name?: string): string {
    const formattedName = stringUtils.formatString(name);
    return formattedName ? `${formattedName} Airport` : '';
  }
}
